import { Routers } from "../../../../../../../constant/Routers"
import { useAuthority } from "../../../../../../../utils/hook/useAuthority"

const { SCR316_HISTORY } = Routers

export const useVariablesAuthority = (pathname: string) => {
  const {
    isAttentionsBrowseResponse,
    isCommonRefer,
    isCommonTravelerRefer,
    isRoleSubAdmin,
    isRoleUser,
  } = useAuthority()

  const isFromHistory = pathname === SCR316_HISTORY
  const isHiddenBtn = isRoleUser || isRoleSubAdmin
  const isHiddenResponseBtn = isHiddenBtn && isCommonTravelerRefer
  const isHiddenResponseHistoryBtn = isFromHistory && isHiddenResponseBtn
  const isHiddenDetailBtn = isRoleSubAdmin && isAttentionsBrowseResponse

  return {
    isCommonRefer,
    isFromHistory,
    isHiddenDetailBtn,
    isHiddenResponseBtn,
    isHiddenResponseHistoryBtn,
    isRoleSubAdmin,
  }
}
